import { ASSET_TYPES } from './assetTypes';
export const OBJECT_TYPE_IDS = {
  LANDING_PAGE: '0-25',
  WEBSITE_PAGE: '0-38',
  WEB_INTERACTIVE: '0-91'
};
export const OBJECT_TYPE_ID_TO_ASSET_TYPE = {
  '0-25': ASSET_TYPES.LANDING_PAGE,
  '0-38': ASSET_TYPES.WEBSITE_PAGE,
  '0-91': ASSET_TYPES.WEB_INTERACTIVE
};

// The CRM object types that variants can be targeted at
export const CRM_OBJECT_TYPE_IDS = {
  CONTACT: '0-1',
  COMPANY: '0-2'
};